module.exports = __webpack_public_path__ + "static/media/close.095ccd1f.svg";